import Survey from '../../../shared/models/survey/Survey';
import SurveyAnswer from '../../../shared/models/survey/SurveyAnswer';
import SurveyRequestResponse from '../../../shared/models/survey/SurveyRequestResponse';
import http from '../../../shared/utils/HttpClient';
import { Result } from '../../dashboard/types';

const getSurvey = async (activationCode: string | null, language: string) => {
  let url = `Surveys/${language || 'nl'}`;

  if (activationCode !== null) {
    url += `?activationCode=${activationCode}`;
  }

  const { data } = await http.get(url, { headers: { Language: language } });
  return SurveyRequestResponse.parse(data);
};

const getSurveyWithResponse = async (activationCode: string | null, responseCode: string, language: string) => {
  const params = [];

  if (activationCode !== null && activationCode !== 'null') {
    params.push(`activationCode=${activationCode}`);
  }

  if (responseCode) {
    params.push(`responseCode=${responseCode}`);
  }

  let url = `Surveys/${language || 'nl'}`;
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  const { data } = await http.get(url, { headers: { Language: language || 'nl' } });
  return {
    survey: Survey.fromJson(data.specification),
    sessionKey: data.sessionKey,
    answers: SurveyAnswer.fromJsonList(data.answers),
  };
};

const postAnswers = async (
  answers: SurveyAnswer[],
  activationCode: string | null,
  saveData: boolean,
  email?: string,
  sessionKey?: string
): Promise<Result> => {
  const language = localStorage.getItem('i18nextLng') ?? 'nl';
  const dataObj: {
    answers: SurveyAnswer[];
    activationCode: string | null;
    saveData: boolean;
    emailAddress?: string;
    sessionKey?: string;
  } = {
    answers,
    activationCode,
    saveData,
  };

  if (sessionKey) dataObj.sessionKey = sessionKey;
  if (email) dataObj.emailAddress = email;

  const { data } = await http.post(`Responses?surveyId=1&language=${language}`, dataObj);
  // @ts-ignore
  return { data };
};

export { getSurvey, getSurveyWithResponse, postAnswers };
